import { IQService } from 'angular'
import { StateService } from 'angular-ui-router'
import { EmployeeService, PayrollService, TimeEntryService, IcdCorporationService } from '../../../core/services'
import { PermissionGrantService } from '../../../core/services/data-services/permission-grant.service'
import { UtilityService } from '../../../core/services/utility.service'
import { TimeGapDecorator } from '../time-gap-decorator.service'
import templateUrl from './list-time-entries-exceptions.component.html'

export const ListTimeEntriesExceptionsComponent = {
    templateUrl,
    controller: ListTimeEntriesExceptionsController,
    controllerAs: "vm",
    bindings: {
        tab: "<",
        tabIndices: "<",
        exceptions: "<?",
        viewPayroll: "&",
        viewTimeEntry: "&",
        onChangeStatus: "&"
    }
}



function ListTimeEntriesExceptionsController($q: IQService, $uibModal: any, $state: StateService,
    employeeService: EmployeeService, utilityService: UtilityService, payrollService: PayrollService, icdCorporationService: IcdCorporationService,
    payrollDashboardService, permissionGrantService: PermissionGrantService, timeGapDecorator: TimeGapDecorator, timeEntryService: TimeEntryService, apexApiUrl: string) {
    'ngInject'

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    vm.$onInit = onInit;
    vm.exceptions;
    vm.changeStatus = changeStatus;
    vm.onViewPayroll = goToPayroll;
    vm.onViewTimeEntry = goToTimeEntry;

    function onInit() {
        vm.exceptions = vm.exceptions;
    }

    function goToPayroll(payrollID) {
        vm.viewPayroll({ payrollID: payrollID });
    }

    function goToTimeEntry(icdCorporationID, startDate, endDate) {
        vm.viewTimeEntry({ icdCorporationID: icdCorporationID, startDate: startDate, endDate: endDate })
    }

    function changeStatus(batchID, status) {
        vm.onChangeStatus({ batchID: batchID, status: status });
        //const update = timeEntryService.updateTimeEntryException(batchID, status);
        //this.utilityService.showLoadingUntilResolved(timeEntryService.updateTimeEntryException(batchID, status), "Assigning failed").then((result) => {
        //    vm.exceptions = result;
        //    vm.pendingExceptions = result.filter(t => t.IsPending);
        //    vm.workedExceptions = result.filter(t => t.IsWorkedOn);
        //    vm.processedExceptions = result.filter(t => t.IsProcessed);
        //});
    }



}
